import React from "react";
import { EvtHeader } from "components/header";
import MeetingForm from "../form";

export default function CreateMeeting() {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Meeting" />
      <div className="max-w-md p-4 lg:p-6">
        <MeetingForm />
      </div>
    </div>
  );
};
